let mixins = {
    methods: {
        fetchProducts(showFilter = false) {
            API.GET(this.productsUrl).then(response => {
                this.products = response.data;
                this.showFilters = showFilter;
            });
        }
    }
};